module.exports = __webpack_public_path__ + "img/administracion.5a4f8580.svg";